import React from 'react';

interface StatusFilterBadgeProps {
  status: 'error' | 'pending' | 'completed' | 'processing';
}

const STATUS_CONFIG = {
  completed: {
    label: 'Concluído',
    icon: 'check',
    color: 'success',
  },
  pending: {
    label: 'Pendente',
    icon: 'hourglass_top',
    color: 'warning',
  },
  processing: {
    label: 'Processando',
    icon: 'hourglass_top',
    color: 'info',
  },
  error: {
    label: 'Erro',
    icon: 'close',
    color: 'danger',
  },
};

const StatusFilterBadge = ({ status }: StatusFilterBadgeProps) => {
  const config = STATUS_CONFIG[status];

  if (!config) return null;

  return (
    <span
      className={`badge badge-${config.color} d-flex align-items-center mr-2`}
      style={{
        padding: '4px 10px',
        fontSize: 13,
        lineHeight: 1,
        borderRadius: 8,
      }}
    >
      <i
        className="material-icons mr-1"
        style={{ fontSize: 16, display: 'flex', alignItems: 'center' }}
      >
        {config.icon}
      </i>

      {config.label}
    </span>
  );
};

export default StatusFilterBadge;
